




















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OverlayWindow from "../general/OverlayWindow.vue";
import EventsCalendarView from "./EventsCalendarView.vue";
import EventsEventDetails from "./EventsEventDetails.vue";

export default Vue.extend({
  name: "EventsCalendarOverlay",
  components: {
    OverlayWindow,
    Loading,
    EventsCalendarView,
    EventsEventDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      loading: false,
      showBookingDetails: false,
      showEventDetails: false,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
      detailsMode: "read",
      reloadCalendar: new Date() as Date,
    };
  },
  beforeCreate() {
    //component import to solve use recursive components
    //https://v2.vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
    if (this.$options && this.$options.components) {
      this.$options.components.EventsBookingDetails = require("./EventsBookingDetails.vue").default;
    }
  },
  created() {},
  methods: {
    /*** START: details view ***/
    toggleBookingDetails() {
      this.showBookingDetails = !this.showBookingDetails;

      if (this.showBookingDetails == false) {
        this.reloadCalendar = new Date();
      }
    },

    toggleEventDetails() {
      this.showEventDetails = !this.showEventDetails;

      if (this.showEventDetails == false) {
        this.reloadCalendar = new Date();
      }
    },

    openDetails(eventId: number | null, bookingId: number | null) {
      this.selectedEventId = eventId;
      this.selectedEventBookingId = bookingId;

      this.detailsMode = "read";

      if (eventId && bookingId) {
        this.toggleBookingDetails();
      } else if (eventId && bookingId == null) {
        this.toggleEventDetails();
      }
    },
    /*** END: details view ***/

    closeCalendarOverlay() {
      this.$emit("close");
    },
  },
  watch: {},
  computed: {},
});
